import React from 'react';
import CustomButton from '../Reusable/CustomButton';
import { Card, Col, Row } from 'react-bootstrap';

const ButtonsDemo = () => {
  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Dugmići
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
              disabled
              fullWidth
            />
          </Col>
          <Col>
            <CustomButton
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              fullWidth
            />
          </Col>
          <Col>
            <CustomButton
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
              fullWidth
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-success'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-success'}
              label="Lorem ipsum"
              fullWidth
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-success'}
              label="Lorem ipsum"
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-info'}
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-info'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              fullWidth
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-info'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
              fullWidth
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-warning'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-warning'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-warning'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-danger'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-danger'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-danger'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-primary'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-primary'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-primary'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
            />
          </Col>
        </Row>
        <Row className="d-flex align-items-center m-2 gap-2">
          <Col>
            <CustomButton
              className={'default-btn-light'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'small'}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-light'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
            />
          </Col>
          <Col>
            <CustomButton
              className={'default-btn-light'}
              label="Lorem ipsum"
              startIcon={<i className="fa-solid fa-file-pen"></i>}
              size={'large'}
              tooltipText={
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
              }
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ButtonsDemo;
